<br />
<br />
<br />
<br />
<br />

<div class="generate">{{ "Generate Your Resume" | translate }}</div>
<div class="my-4 d-none d-md-block">
  <p-steps [model]="steps" [(activeIndex)]="activeIndex" />
</div>

<app-resme-target
  *ngIf="activeIndex === 0"
  (next)="next()"
  (previous)="previous()"
  [formGroup]="cvForm"
/>

<app-cv-templetes
  *ngIf="activeIndex === 1"
  (previous)="previous()"
  (next)="next()"
  [formGroup]="cvForm"
/>
<app-select-resume
  *ngIf="activeIndex == 2"
  (next)="next()"
  (previous)="previous()"
  [formGroup]="cvForm"
/>
<app-personal-data
  *ngIf="activeIndex === 3"
  [formGroup]="cvForm"
  (next)="next()"
  (previous)="previous()"
/>
<app-work-experience
  *ngIf="activeIndex === 4"
  [formGroup]="cvForm"
  (next)="next()"
  (previous)="previous()"
/>
<app-education
  *ngIf="activeIndex === 5"
  [formGroup]="cvForm"
  (next)="next()"
  (previous)="previous()"
/>

<app-skills
  *ngIf="activeIndex === 6"
  [formGroup]="cvForm"
  (next)="DownloadResume()"
  (previous)="previous()"
/>
